import { useSentry } from '@/plugins/sentry';

import { BaseLogger } from './baseLogger';

import type {
  ILogger,
  LogLevels,
} from '../interface';

export class SentryLogger extends BaseLogger implements ILogger {
  log (level: LogLevels, data: Error | string | unknown): void {
    if (!this.isEnabled(level)) {
      return;
    }

    const sentry = useSentry();
    switch (level) {
      case 'error': {
        sentry.captureException(data);

        return;
      }
    }

    console.error(`level ${ level } logging is not implemented`);
  }
}
